import React from 'react';
import { render } from 'react-dom';

import '@low/feature-flag-client-initial';
import RwcApp from '@low/containers/rwc-app';

export default function appInitialize(VCAppGetter) {
    render(<RwcApp VCAppGetter={VCAppGetter} />, document.getElementById('mount-point'));
}
